import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import { AccessControlTabs } from '@features/Admin/AccessControl';
import PageContainer from '@shared/components/container/PageContainer';
import { useAppDispatch } from '@shared/store';
import { actions } from '@shared/store/ducks';

const AccessControlPage: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(actions.customizer.toggleLayout('full'));
  }, [dispatch]);

  return (
    <PageContainer title={t('accessControl.title')} description={t('accessControl.title')}>
      <Box sx={(theme) => ({ padding: theme.spacing(3) })}>
        <Typography variant="h4" fontWeight={600}>
          {t('accessControl.title')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 2 }}>
          {t('accessControl.subtitle')}
        </Typography>
        <AccessControlTabs />
      </Box>
    </PageContainer>
  );
};

export { AccessControlPage };
